import { passwordRules, enterpriseTypeRules } from '@/utils/formValidateRules'
export const localsProvince = [
    '北京市',
    '上海市',
    '天津市',
    '重庆市',
    '湖北省',
    '湖南省',
    '广东省',
    '河南省',
    '河北省',
    '山东省',
    '山西省',
    '江苏省',
    '江西省',
    '浙江省',
    '黑龙江省',
    '辽宁省',
    '吉林省',
    '甘肃省',
    '青海省',
    '陕西省',
    '海南省',
    '福建省',
    '安徽省',
    '云南省',
    '贵州省',
    '四川省',
    '广西壮族自治区',
    '宁夏回族自治区',
    '内蒙古自治区',
    '西藏自治区',
    '新疆维吾尔自治区',
    '台湾省',
    '香港特别行政区',
    '澳门特别行政区'
]

export const enterpriseType = [
    {
        value: '施工单位',
        label: '施工单位'
    },
    {
        value: '设计单位',
        label: '设计单位'
    },
    {
        value: '建设方',
        label: '建设方'
    },
    {
        value: '科技公司',
        label: '科技公司'
    },
    {
        value: '高校',
        label: '高校'
    }
]

export const rules = {
    phone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的11位手机号'
        },
        {
            validator: (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入手机号'))
                    return
                }

                if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
                    callback()
                } else {
                    callback(new Error('手机号格式不正确'))
                }
            },
            trigger: 'blur'
        }
    ],
    password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: 'blur'
        }
    ],
    enterpriseType: [
        {
            required: true,
            message: '请选择企业类型',
            trigger: 'change'
        },
        {
            pattern: enterpriseTypeRules.enterpriseType,
            message: enterpriseTypeRules.enterpriseType,
            trigger: 'change'
        }
    ],
    province: [
        {
            required: true,
            message: '请选择省份',
            trigger: 'change'
        }
    ],
    validateNo: [
        {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
        }
    ]
}
